mod.modules.define("Plugin-CustomColumns", function(fn) {

	var $window = null;
	var $documentBody = null;

	fn.prototype.init = function(params) {
		this.tableId = params.tableId || "";
		this.maxColumns = params.maxColumns || 5;

		$window = $(window);
		$documentBody = $(document.body);
	};

	fn.prototype.showModal = function() {
		var id = "com_customizetablecolumns";
		var widgetId = "widget-" + id;

		// Create a wrapper for the modal
		var $modalWrapper = $("<div class='loading modal customcolumns-modal' />").append(
			// Add a placeholder that will be replaced by the new widget
			$("<div class='loading-indicator' id='" + widgetId + "' />")
		).modal({
			backdrop: "static", // Prevent the modal from closing on blur
			show: false
		})
		.off("show.bs.modal")
		.on("show.bs.modal", function() {
			// Reposition the modal
			var $modal = $(this);
			var currentTop = $modal.position().top;
			var windowTop = $window.scrollTop();
			var spacing = 100;
			$modal.css("top", currentTop + windowTop + spacing);
		})
		.modal("show");

		// Load the new widget
		mod.modules.widgetapi.load({
			widgets: {
				appId: id,
				context: {
					TableId: this.tableId,
					MaxColumns: this.maxColumns
				}
			},
			success: function() {
				$modalWrapper.removeClass("loading");

				$modalWrapper.on("hide.bs.modal", function () {
					// Remove the widget completely when the modal is closed
					var widgetClass = $("#" + widgetId).data("widget");

					if (widgetClass) {
						widgetClass.dispose(true);
					}

					$(this).remove();
				});
			}
		});
	};

});